import { Errors } from 'shared/errors';

export async function uploadFileToS3(endpoint: string, file: File, progressCallback?: (progress: number) => void): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.onreadystatechange = () => {
            const { readyState, status } = xhr;
            if (readyState === 4) {
                if (status >= 200 && status < 300) {
                    console.log('upload complete');
                    progressCallback && progressCallback(1);
                    resolve();
                }
                else {
                    console.error(`upload failed: ${status}`);
                    reject(new Error(Errors.ACCESS_DENIED));
                }
            }
        };

        if (progressCallback) {
            xhr.addEventListener('progress', e => {
                if (e.lengthComputable) {
                    const progress = e.loaded / e.total;
                    progressCallback(progress);
                }
            });
        }

        try {
            xhr.open("PUT", endpoint, true);
            xhr.setRequestHeader("Content-Type", file.type);
            xhr.setRequestHeader("Cache-Control", "max-age=7948800"); // Approximately three months
            xhr.send(file);
        }
        catch (err) {
            reject(err);
        }
    });
}
